<template>
  <FilterPopper>
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="'Images With Annotation Labels'"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div v-if="labels && Object.values(labels).length > 0" class="filter-settings scrollbar">
        <div v-for="(label, i) in labels" :key="i" class="filter-settings__row">
          <input
            :id="`annotationLabelFilter-${label.name}-${i}`"
            v-model="selectedLabels"
            type="checkbox"
            :name="`selected-labels`"
            :value="label.index"
          >
          <label :for="`annotationLabelFilter-${label.name}-${i}`">{{ label.name }}</label><br>
        </div>
      </div>
      <div v-else class="filter-settings">
        Please define a label.
      </div>
      <div class="filter-footer">
        <button :disabled="!isActive" class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script>
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';

export default {
  name: "AnnotationLabelFilter",
  components: {
    FilterPopper,
    BaseFilterButton,
  },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    invert: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:modelValue',
  ],
  data() {
    return {
      selectedLabels: [],
    };
  },
  computed: {
    isActive() {
      return this.selectedLabels.length > 0;
    },
    tagValue() {
      return this.selectedLabels.length.toString();
    },
  },
  watch: {
    labels: {
      deep: true,
      immediate: true,
      handler() {
        this.selectedLabels = [];
      },
    },
    modelValue(newVal) {
      this.selectedLabels = newVal;
    },
    selectedLabels() {
      this.updateFilters();
    },
  },
  methods: {
    updateFilters() {
      this.$emit('update:modelValue', this.selectedLabels);
    },
    clearSelection() {
      this.selectedLabels = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 6px;
  min-width: 200px;
  overflow: auto;

  &__row {
    display: flex;
    align-items: center;
  }

  & input[type=checkbox] {
    margin-right: 12px;
  }
}

.filter-footer {
  min-height: 38px;
  width: 100%;
  border-top: 1px solid rgba(140,140,140,0.375);
  padding: 8px;
  text-align: center;

  .clear-button {
    text-align: center;
    @include themify() {
      color: themed('color-danger');
    }

    &[disabled] {
      @include themify() {
        color: themed('color-disabled');
      }
    }
  }
}
</style>
